module.exports = __webpack_public_path__ + "img/Instagram.314e380e.svg";